"use client";

import { useEffect } from "react";
import { CHAVES_DA_ORIGEM } from "@/lib/camp/origem";

/**
 * Repassa `src`, `utm_*`, `coach` e `cupom` da URL da página para os links de
 * inscrição (30/09/2026). A página do camp é estática (ISR) e não pode ler a
 * URL no servidor sem virar dinâmica, o que custaria o carregamento no 4G do
 * Instagram. Então isto roda no navegador, depois de montar: acha os links
 * que terminam em `/inscricao` e acrescenta o que faltar, sem mexer no
 * `?turma=` que já está lá.
 *
 * O cookie `camp_origem` do proxy é a segunda rede: quem não passar por estes
 * links ainda credita a origem.
 */
export default function RepassaOrigem() {
  useEffect(() => {
    const atual = new URLSearchParams(window.location.search);
    // `cupom` (Foxes, 20/10/2026): o link do técnico leva o desconto até a inscrição.
    const levar = [...CHAVES_DA_ORIGEM, "coach", "cupom"].filter((k) => atual.get(k));
    if (levar.length === 0) return;
    document.querySelectorAll<HTMLAnchorElement>('a[href*="/inscricao"]').forEach((a) => {
      const url = new URL(a.getAttribute("href") ?? "", window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.endsWith("/inscricao")) return;
      for (const k of levar) if (!url.searchParams.has(k)) url.searchParams.set(k, atual.get(k)!);
      a.setAttribute("href", `${url.pathname}${url.search}`);
    });
  }, []);
  return null;
}
